import * as types from './mutation-types';
// 提交mutation
function makeAction (type) {
  return ({ commit }, ...args) => commit(type, ...args);
};

export const setInfo = makeAction(types.SET_INFO);
export const setPerson = makeAction(types.SET_PER);
export const setOrg = makeAction(types.SET_ORG);

export const setUrl = makeAction(types.SET_URL);




// WEBPACK FOOTER //
// ./src/store/actions.js